export default "__VITE_ASSET__BH_51Zax__"